import React from 'react'
import styles from "./workDetailSec.module.css";
import WorkDetailBanner from './WorkDetailBanner';
import WorkDetailDisc from './WorkDetailDisc';
import WorkDetailBranding from './WorkDetailBranding';
import ServiceDetailServiceList from '../serviceDetail-section/ServiceDetailServiceList';
import WorkDetailServiceList from './WorkDetailServiceList';


const WorkDetailSec = ({workData, workDetails}) => {
    return (
        <div className={styles.WorkDetailSec}>
            <WorkDetailBanner  workData = {workData}/>
            
            {/* <WorkDetailDisc workData = {workData} /> */}
            <WorkDetailServiceList workData={workData} />
            {/* <WorkDetailBranding /> */}
           {/*  {Array.isArray(workDetails) && workDetails.length > 0 && <WorkDetailBranding workDetails = {workDetails}/>} */}


        </div>
    )
}

export default WorkDetailSec
